import { Link } from "react-router-dom";
import { TOOLS } from "../data/tools.js";
import { XUAT_CHO_NHA_DAU_TU } from "../lib/motTrang.js";
import { nhanNguon, SO_NGAY_CU, TRAN_TEN_TAI_LIEU } from "@shared/nguonSo.js";

/**
 * Trong mục "Hồ sơ gửi nhà đầu tư": với mỗi khối số sẽ xuất ra bản gửi nhà
 * đầu tư, founder chọn nguồn (tự tính, hoặc có tài liệu đối chiếu kèm tên) và
 * thấy ngày tính. Số cũ hơn SO_NGAY_CU ngày thì nhắc chạy lại công cụ.
 *
 * Chỉ liệt kê công cụ trong danh sách cho phép của bản gửi nhà đầu tư; các
 * khối còn lại không rời khỏi máy nên không cần nhãn.
 */
export default function NguonKhoiSo({ data, setProfile }) {
  const nguonSo = data.profile?.nguonSo || {};
  const khoi = Object.entries(data.drafts || {})
    .filter(([id]) => XUAT_CHO_NHA_DAU_TU.has(id))
    .map(([id, d]) => ({ id, d, tool: TOOLS.find((t) => t.toolId === id) }))
    .filter((k) => k.tool);
  if (!khoi.length) return null;

  const sua = (id, patch) => {
    const cu = nguonSo[id] || { loai: "tu-tinh" };
    setProfile({ nguonSo: { ...nguonSo, [id]: { ...cu, ...patch } } });
  };

  return (
    <fieldset className="nguon-khoi-so">
      <legend>Nguồn của từng khối số</legend>
      <p className="ghi-chu-nho">
        Nhà đầu tư sẽ hỏi số lấy từ đâu và tính lúc nào. Nếu có sao kê, báo cáo tài chính
        hay hợp đồng để đối chiếu, ghi tên tài liệu; bạn gửi tài liệu riêng khi được hỏi.
        Fundraising.vn không xem hay xác nhận tài liệu.
      </p>
      <ul>
        {khoi.map(({ id, d, tool }) => {
          const n = nhanNguon(nguonSo[id], d.updated);
          const chon = nguonSo[id]?.loai === "co-tai-lieu" ? "co-tai-lieu" : "tu-tinh";
          return (
            <li key={id} className="nks-dong">
              <div className="nks-tren">
                <strong>{tool.title}</strong>
                <span className={n.cu ? "nks-ngay nks-cu" : "nks-ngay"}>
                  {n.ngay ? `Số liệu ngày ${n.ngay}` : "Chưa rõ ngày"}
                </span>
              </div>
              {n.cu && (
                <p className="nks-nhac">
                  Số đã hơn {Math.round(SO_NGAY_CU / 30)} tháng.{" "}
                  <Link to={`/cong-cu/${tool.slug}`}>Cập nhật trước khi gửi →</Link>
                </p>
              )}
              <div className="nks-chon" role="radiogroup" aria-label={`Nguồn số liệu: ${tool.title}`}>
                <label>
                  <input type="radio" name={`nguon-${id}`} checked={chon === "tu-tinh"}
                    onChange={() => sua(id, { loai: "tu-tinh" })} />
                  <span>Tự tính</span>
                </label>
                <label>
                  <input type="radio" name={`nguon-${id}`} checked={chon === "co-tai-lieu"}
                    onChange={() => sua(id, { loai: "co-tai-lieu" })} />
                  <span>Có tài liệu đối chiếu</span>
                </label>
              </div>
              {chon === "co-tai-lieu" && (
                <label className="nks-tai-lieu">
                  <span>Tên tài liệu</span>
                  <input type="text" maxLength={TRAN_TEN_TAI_LIEU}
                    placeholder="Ví dụ: sao kê ngân hàng 07 đến 09/2026"
                    value={nguonSo[id]?.taiLieu || ""}
                    onChange={(e) => sua(id, { taiLieu: e.target.value })} />
                  {!String(nguonSo[id]?.taiLieu || "").trim() && (
                    <small>Chưa có tên tài liệu thì hồ sơ vẫn ghi "tự tính".</small>
                  )}
                </label>
              )}
              <p className="nks-xem"><small>Trên hồ sơ: {n.chu}</small></p>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
